import Logo from '@assets/images/common/brand/logo-primary.svg';
import { brandColors } from '@src/assets/colors/brandColors';
import SvgIconArticle from '@src/assets/images/common/icon/category/SvgIconArticle';
import Button from '@src/ui/elements/button/Button';
import UserGuideLink from '@src/ui/elements/button/UserGuideLink';
import Footer from '@src/ui/templates/Company/Footer/Footer';
import { NavItem } from '@src/ui/templates/Company/NavMenu/types';
import React from 'react';
import { Link } from 'react-router-dom';

type Props = {
  children: React.ReactNode;
  pageName?: string;
  showSidebar?: boolean;
};

type Category = {
  label: string;
  to: string;
  isCurrent: boolean;
};

function TenantPreviewLayout({ children }: Props) {
  const categories: Category[] = Array.from({ length: 3 }, (_, i) => ({
    label: `サイドメニュー${++i}`,
    to: '',
    isCurrent: i === 1,
  }));

  const navItems: NavItem[] = Array.from({ length: 4 }, (_, i) => ({
    title: `メインメニュー${++i}`,
    link: '',
    isLocked: false,
    isComingSoon: false,
    adminOnly: false,
    current: i === 1,
  }));

  return (
    <div className='min-h-screen'>
      <div className='flex lg:block'>
        <div className='sticky top-0 h-screen overflow-hidden lg:hidden'>
          <div className='h-screen w-[240px] shrink-0 overflow-y-auto xl:w-[200px]'>
            <aside className='size-full border-r border-solid border-r-gray-200 bg-white'>
              <Link
                to=''
                className='block p-[10px]'
              >
                <img
                  className='block size-full max-h-[40px] object-contain'
                  src={Logo}
                  alt='DXSTAR for Bank'
                  width='220'
                  height='40'
                />
              </Link>
              <ul className='px-4 pb-8'>
                {categories.map((category, index) => (
                  <li key={index}>
                    <Link
                      className='flex w-full'
                      to={category.to}
                    >
                      <div
                        className={`flex items-center gap-2 truncate py-3 ${
                          category.isCurrent && '!border-b-2 border-b-primary-500 text-primary-500'
                        }`}
                      >
                        <SvgIconArticle
                          color={category.isCurrent ? brandColors['500'] : '#d9d9d9'}
                          style={{
                            width: '14px',
                            height: '14px',
                            paddingTop: '2px',
                            flex: '0 0 auto',
                          }}
                        />
                        <span className='truncate text-sm'>{category.label}</span>
                      </div>
                    </Link>
                  </li>
                ))}
              </ul>
            </aside>
          </div>
        </div>

        <div className='flex w-[calc(100%-240px)] flex-col xl:w-[calc(100%-200px)] lg:w-full lg:pt-[60px]'>
          <header className='sticky top-0 z-50 flex h-[61px] w-full border-b border-gray-200 bg-white pl-8 xl:pl-3 lg:hidden'>
            <div className='flex w-full items-center justify-between'>
              <nav className='size-full pr-4'>
                <ul className='flex h-full items-center gap-2 xl:gap-1 xl:text-sm'>
                  {navItems.map((item: NavItem, index: number) => (
                    <li
                      key={index}
                      className={`relative h-full border-b-2 transition-colors
                  ${item.current ? 'border-primary text-primary' : 'border-white'}
                  ${index < 4 ? 'flex-[0_0_auto]' : ''}
                `}
                    >
                      <button
                        className='flex h-full items-center px-2 xl:px-1'
                        data-nav-target={item.link}
                      >
                        <span>{item.title}</span>
                      </button>
                    </li>
                  ))}
                </ul>
              </nav>
              <UserGuideLink
                userType='company'
                device='pc'
                color='gray'
              />
              <div className='flex flex-[0_0_auto] items-center gap-[10px] border-l border-solid border-l-gray-200 pl-6 pr-2 xl:gap-[5px] xl:pl-3'>
                <Button
                  size='s'
                  fullRounded
                  outline
                >
                  ログイン
                </Button>
                <Button
                  size='s'
                  fullRounded
                  outline
                >
                  新規会員登録
                </Button>
              </div>
            </div>
          </header>
          <div className='grow'>{children}</div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default TenantPreviewLayout;
